export interface RouteSeo {
  title: string;
  description: string;
  keywords: string;
  image: string;
  type: string;
}

/**
 * Per-route SEO data. Indexable public routes only.
 * Route order matches the app router (src/router/config.tsx).
 */
export const routeSeo: Record<string, RouteSeo> = {
  '/': {
    title: 'Penland LLC | Bookkeeping, Consulting, Properties, Software & Travel',
    description:
      'Penland LLC is a Virginia company operating Penland Bookkeeping, Consulting & Web Development, Penland Properties, MatchLineup, and Alabaster Travel.',
    keywords:
      'Penland LLC, Virginia bookkeeping, consulting, property management, Alabaster Travel',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20layered%20architectural%20forms%20and%20soft%20geometric%20planes%20in%20deep%20navy%20teal%20and%20warm%20sand%20tones%2C%20elegant%20minimal%20corporate%20backdrop%20with%20subtle%20depth%20and%20cinematic%20soft%20lighting%2C%20high-end%20editorial%20style%2C%20smooth%20gradients&width=1600&height=900&seq=penland-home-hero-01&orientation=landscape',
    type: 'website',
  },
  '/bookkeeping': {
    title: 'Penland Bookkeeping | Bookkeeping in Richmond, VA',
    description:
      'Specialized bookkeeping for restaurants, cafes, bars, skilled trades, small businesses, and nonprofits in Richmond, Henrico, and Chesterfield, Virginia.',
    keywords:
      'Penland Bookkeeping, Richmond bookkeeping, restaurant bookkeeping, contractor bookkeeping, nonprofit bookkeeping',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20bookkeeping%20consultation%20meeting%20in%20modern%20office%20with%20warm%20natural%20lighting%2C%20financial%20documents%20and%20laptop%20on%20table%2C%20two%20business%20people%20reviewing%20reports%20together%2C%20clean%20minimalist%20interior%20design%2C%20soft%20neutral%20warm%20tones%2C%20editorial%20photography%20style&width=1600&height=900&seq=hero-penland-01&orientation=landscape',
    type: 'website',
  },
  '/consulting': {
    title: 'Penland Consulting & Web Development | Penland LLC',
    description:
      'Penland LLC provides operations, financial, and web development consulting for owner-operated businesses and nonprofits in Virginia.',
    keywords:
      'Penland consulting, web development, operations consulting, financial consulting, Virginia',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20flowing%20geometric%20lines%20and%20soft%20gradient%20planes%20in%20deep%20navy%20and%20teal%2C%20minimal%20corporate%20technology%20backdrop%2C%20cinematic%20soft%20lighting%2C%20elegant%20high-end%20editorial%20style&width=1600&height=900&seq=consulting-hero-01&orientation=landscape',
    type: 'website',
  },
  '/properties': {
    title: 'Penland Properties | Residential Property Management in VA',
    description:
      'Penland Properties manages long-term and short-term residential rental property, handling leasing, tenant relations, maintenance, and taxes in Virginia.',
    keywords:
      'Penland Properties, residential property management, rental property, Virginia property management, short-term rentals',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20minimal%20residential%20architecture%20facade%20with%20clean%20lines%20and%20warm%20neutral%20tones%2C%20soft%20dusk%20lighting%2C%20elegant%20architectural%20editorial%20photography%2C%20subtle%20depth%20and%20calm%20atmosphere&width=1600&height=900&seq=properties-hero-01&orientation=landscape',
    type: 'website',
  },
  '/matchlineup': {
    title: 'MatchLineup | Tennis Team Match Scheduling Software',
    description:
      'MatchLineup is tennis match scheduling software for adult recreational teams. Captains post matches, players respond, and lineups are set in minutes.',
    keywords:
      'MatchLineup, tennis scheduling software, tennis lineup app, team match scheduling, SMS reminders',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20tennis%20court%20aerial%20view%20with%20clean%20geometric%20lines%20in%20teal%20and%20navy%20tones%2C%20minimal%20sport%20backdrop%20with%20soft%20light%20and%20elegant%20composition&width=1600&height=900&seq=matchlineup-hero-01&orientation=landscape',
    type: 'website',
  },
  '/alabaster': {
    title: 'Alabaster Travel | Independent Travel Advisory',
    description:
      'Alabaster Travel offers independent travel advisory, itinerary design, booking, group travel, and concierge support for individuals, families, and groups.',
    keywords:
      'Alabaster Travel, travel advisor, itinerary design, group travel, concierge travel support',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20dreamy%20coastal%20horizon%20with%20soft%20gradient%20sky%20and%20calm%20sea%20in%20warm%20sand%20and%20teal%20tones%2C%20minimal%20elegant%20travel%20backdrop%2C%20cinematic%20soft%20light%20and%20subtle%20mist&width=1600&height=900&seq=alabaster-hero-01&orientation=landscape',
    type: 'website',
  },
};

export const notFoundSeo = {
  title: 'Page Not Found | Penland LLC',
  description: 'The page you are looking for is not available on the Penland LLC website.',
};